import Box from "../components/pics/box.svg";
import Chosing from "../components/pics/shopping.svg";
import Delivery from "../components/pics/delivery.svg";

const data = [
  {
    id: 1,
    body: "Buy everything you need by clicking the icons",
    icon: Chosing,
  },
  { id: 2, body: "Fast deliver to your house", icon: Delivery },
  { id: 3, body: "Pick up the items", icon: Box },
];
export default data;
